unit View.Nbs.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls, UUtils,
  UHelperServer, UWeb.Enum;

type
  TFViewNbsEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnbs: TLabel;
    ednbs: TDBEdit;
    lbdescricao: TLabel;
    eddescricao: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientNbsGet: TXDataWebClient;
    NbsDataset: TXDataWebDataSet;
    NbsDatasetid: TIntegerField;
    NbsDatasetnbs: TStringField;
    NbsDatasetdescricao: TStringField;
    NbsDatasetexcluido: TBooleanField;
    NbsDatasetinclusao: TDateTimeField;
    NbsDatasetalteracao: TDateTimeField;
    NbsDatasetexclusao: TDateTimeField;
    cbExcluido: TDBCheckBox;
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientNbsGetLoad(Response: TXDataClientResponse);
    procedure NbsDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormShow(Sender: TObject);
    procedure ednbsClick(Sender: TObject);
    procedure eddescricaoClick(Sender: TObject);
    procedure ednbsKeyPress(Sender: TObject; var Key: Char);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewNbsEdit: TFViewNbsEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewNbsEdit }

procedure TFViewNbsEdit.btSaveClick(Sender: TObject);
begin
  if THelperServer.VerificarCampoVazio(ednbs) then
  begin
    TUtils.SetErroClass('lbnbs', 'Preencha o NBS!');
    Exit;
  end
  else if (Length(trim(ednbs.Text)) <> 9) then
  begin
    TUtils.SetErroClass('lbnbs', 'Campo NBS deve ter 9 caracteres!');
    Exit;
  end;

  if THelperServer.VerificarCampoVazio(eddescricao) then
  begin
    TUtils.SetErroClass('lbdescricao', 'Preencha a descrição!');
    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, THelperServer.GetMensagemPadraoSalvar(FInserting))) then
  begin
    if NbsDataset.State in dsEditModes then
    begin
      NbsDataset.Post;
      NbsDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;

class function TFViewNbsEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewNbsEdit.eddescricaoClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('lbdescricao');
end;

procedure TFViewNbsEdit.ednbsClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('lbnbs');
end;

procedure TFViewNbsEdit.ednbsKeyPress(Sender: TObject; var Key: Char);
begin
  if not(key in ['0'..'9']) Then
    key := #0;
end;

procedure TFViewNbsEdit.InsertEntity;
begin
  NbsDataset.Close;
  NbsDataset.SetJsonData('{}');
  NbsDataset.Open;
  NbsDataset.Insert;
end;

class function TFViewNbsEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewNbsEdit(AForm).FInserting := AInserting;
    TFViewNbsEdit(AForm).FId := AId;
    TFViewNbsEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewNbsEdit(AForm).InsertEntity
    else
      TFViewNbsEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewNbsEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewNbsEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    NbsDataset.Connection.Model.DefaultSchema.FindEntityType(
      NbsDataset.EntitySetName
    )
  );
  XDataClientNbsGet.Get(NbsDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewNbsEdit.XDataClientNbsGetLoad(Response: TXDataClientResponse);
begin
  NbsDataset.Close;
  NbsDataset.SetJsonData(Response.Result);
  NbsDataset.Open;
  
  NbsDataset.Edit;  
end;

procedure TFViewNbsEdit.NbsDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);
      NbsDataset.Edit;
      Exit;
    end;
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, THelperServer.GetMensagemPadraoSalvarSucesso(FInserting));
  FShowListProc;
end;

procedure TFViewNbsEdit.WebFormShow(Sender: TObject);
begin
  if FInserting then
    THelperServer.RemoverDiv('campos-controle')
  else
  begin
    if not TUtils.PossuiPermissao(NbsDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
    begin
      btSave.Enabled := False;
      ednbs.Enabled := False;
      eddescricao.Enabled := False;
      cbExcluido.Enabled := False;
    end;
  end;
end;

procedure TFViewNbsEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewNbsEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.nbs.form.lbid');
  lbnbs := TLabel.Create('view.nbs.form.lbnbs');
  lbdescricao := TLabel.Create('view.nbs.form.lbdescricao');
  lbexcluido := TLabel.Create('view.nbs.form.lbexcluido');
  lbinclusao := TLabel.Create('view.nbs.form.lbinclusao');
  lbalteracao := TLabel.Create('view.nbs.form.lbalteracao');
  lbexclusao := TLabel.Create('view.nbs.form.lbexclusao');
  btCancel := TButton.Create('view.nbs.form.btBack');
  btSave := TButton.Create('view.nbs.form.btSave');
  edid := TDBEdit.Create('view.nbs.form.edid');
  ednbs := TDBEdit.Create('view.nbs.form.ednbs');
  eddescricao := TDBEdit.Create('view.nbs.form.eddescricao');
  edinclusao := TDBEdit.Create('view.nbs.form.edinclusao');
  edalteracao := TDBEdit.Create('view.nbs.form.edalteracao');
  edexclusao := TDBEdit.Create('view.nbs.form.edexclusao');
  cbExcluido := TDBCheckBox.Create('view.nbs.form.cbexcluido');
  DataSource := TDataSource.Create(Self);
  NbsDataset := TXDataWebDataSet.Create(Self);
  NbsDatasetid := TIntegerField.Create(Self);
  NbsDatasetnbs := TStringField.Create(Self);
  NbsDatasetdescricao := TStringField.Create(Self);
  NbsDatasetexcluido := TBooleanField.Create(Self);
  NbsDatasetinclusao := TDateTimeField.Create(Self);
  NbsDatasetalteracao := TDateTimeField.Create(Self);
  NbsDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientNbsGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbnbs.BeforeLoadDFMValues;
  lbdescricao.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednbs.BeforeLoadDFMValues;
  eddescricao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbExcluido.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  NbsDataset.BeforeLoadDFMValues;
  NbsDatasetid.BeforeLoadDFMValues;
  NbsDatasetnbs.BeforeLoadDFMValues;
  NbsDatasetdescricao.BeforeLoadDFMValues;
  NbsDatasetexcluido.BeforeLoadDFMValues;
  NbsDatasetinclusao.BeforeLoadDFMValues;
  NbsDatasetalteracao.BeforeLoadDFMValues;
  NbsDatasetexclusao.BeforeLoadDFMValues;
  XDataClientNbsGet.BeforeLoadDFMValues;
  try
    Name := 'FViewNbsEdit';
    Width := 593;
    Height := 454;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbnbs.SetParentComponent(Self);
    lbnbs.Name := 'lbnbs';
    lbnbs.Left := 24;
    lbnbs.Top := 219;
    lbnbs.Width := 22;
    lbnbs.Height := 13;
    lbnbs.Caption := 'Nbs:';
    lbnbs.HeightPercent := 100.000000000000000000;
    lbnbs.WidthPercent := 100.000000000000000000;
    lbdescricao.SetParentComponent(Self);
    lbdescricao.Name := 'lbdescricao';
    lbdescricao.Left := 24;
    lbdescricao.Top := 246;
    lbdescricao.Width := 50;
    lbdescricao.Height := 13;
    lbdescricao.Caption := 'Descri'#231#227'o:';
    lbdescricao.HeightPercent := 100.000000000000000000;
    lbdescricao.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 273;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 300;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 327;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 354;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 394;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancelar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 394;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Salvar';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ednbs.SetParentComponent(Self);
    ednbs.Name := 'ednbs';
    ednbs.Left := 221;
    ednbs.Top := 216;
    ednbs.Width := 200;
    ednbs.Height := 21;
    ednbs.HeightPercent := 100.000000000000000000;
    ednbs.MaxLength := 9;
    ednbs.TabOrder := 7;
    ednbs.Text := 'ednbs';
    ednbs.WidthPercent := 100.000000000000000000;
    SetEvent(ednbs, Self, 'OnClick', 'ednbsClick');
    SetEvent(ednbs, Self, 'OnKeyPress', 'ednbsKeyPress');
    ednbs.DataField := 'nbs';
    ednbs.DataSource := DataSource;
    eddescricao.SetParentComponent(Self);
    eddescricao.Name := 'eddescricao';
    eddescricao.Left := 221;
    eddescricao.Top := 243;
    eddescricao.Width := 200;
    eddescricao.Height := 21;
    eddescricao.CharCase := wecUpperCase;
    eddescricao.HeightPercent := 100.000000000000000000;
    eddescricao.TabOrder := 8;
    eddescricao.Text := 'eddescricao';
    eddescricao.WidthPercent := 100.000000000000000000;
    SetEvent(eddescricao, Self, 'OnClick', 'eddescricaoClick');
    eddescricao.DataField := 'descricao';
    eddescricao.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 297;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 10;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 324;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 11;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 351;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 12;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbExcluido.SetParentComponent(Self);
    cbExcluido.Name := 'cbExcluido';
    cbExcluido.Left := 221;
    cbExcluido.Top := 270;
    cbExcluido.Width := 200;
    cbExcluido.Height := 22;
    cbExcluido.Caption := 'cbExcluido';
    cbExcluido.ChildOrder := 13;
    cbExcluido.HeightPercent := 100.000000000000000000;
    cbExcluido.WidthPercent := 100.000000000000000000;
    cbExcluido.DataField := 'excluido';
    cbExcluido.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := NbsDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    NbsDataset.SetParentComponent(Self);
    NbsDataset.Name := 'NbsDataset';
    NbsDataset.AfterApplyUpdates := NbsDatasetAfterApplyUpdates;
    NbsDataset.EntitySetName := 'Nbs';
    NbsDataset.Connection := DMConnection.ApiConnection;
    NbsDataset.Left := 176;
    NbsDataset.Top := 8;
    NbsDatasetid.SetParentComponent(NbsDataset);
    NbsDatasetid.Name := 'NbsDatasetid';
    NbsDatasetid.FieldName := 'id';
    NbsDatasetnbs.SetParentComponent(NbsDataset);
    NbsDatasetnbs.Name := 'NbsDatasetnbs';
    NbsDatasetnbs.FieldName := 'nbs';
    NbsDatasetnbs.Required := True;
    NbsDatasetnbs.Size := 255;
    NbsDatasetdescricao.SetParentComponent(NbsDataset);
    NbsDatasetdescricao.Name := 'NbsDatasetdescricao';
    NbsDatasetdescricao.FieldName := 'descricao';
    NbsDatasetdescricao.Required := True;
    NbsDatasetdescricao.Size := 255;
    NbsDatasetexcluido.SetParentComponent(NbsDataset);
    NbsDatasetexcluido.Name := 'NbsDatasetexcluido';
    NbsDatasetexcluido.FieldName := 'excluido';
    NbsDatasetinclusao.SetParentComponent(NbsDataset);
    NbsDatasetinclusao.Name := 'NbsDatasetinclusao';
    NbsDatasetinclusao.FieldName := 'inclusao';
    NbsDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    NbsDatasetalteracao.SetParentComponent(NbsDataset);
    NbsDatasetalteracao.Name := 'NbsDatasetalteracao';
    NbsDatasetalteracao.FieldName := 'alteracao';
    NbsDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    NbsDatasetexclusao.SetParentComponent(NbsDataset);
    NbsDatasetexclusao.Name := 'NbsDatasetexclusao';
    NbsDatasetexclusao.FieldName := 'exclusao';
    NbsDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    XDataClientNbsGet.SetParentComponent(Self);
    XDataClientNbsGet.Name := 'XDataClientNbsGet';
    XDataClientNbsGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientNbsGet, Self, 'OnLoad', 'XDataClientNbsGetLoad');
    XDataClientNbsGet.Left := 64;
    XDataClientNbsGet.Top := 8;
  finally
    lbid.AfterLoadDFMValues;
    lbnbs.AfterLoadDFMValues;
    lbdescricao.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednbs.AfterLoadDFMValues;
    eddescricao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbExcluido.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    NbsDataset.AfterLoadDFMValues;
    NbsDatasetid.AfterLoadDFMValues;
    NbsDatasetnbs.AfterLoadDFMValues;
    NbsDatasetdescricao.AfterLoadDFMValues;
    NbsDatasetexcluido.AfterLoadDFMValues;
    NbsDatasetinclusao.AfterLoadDFMValues;
    NbsDatasetalteracao.AfterLoadDFMValues;
    NbsDatasetexclusao.AfterLoadDFMValues;
    XDataClientNbsGet.AfterLoadDFMValues;
  end;
end;

end.
